import React, { useState, useRef } from "react";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './career.css';

export default function Career() {
    const [BookFromData, setBookFromData] = useState({
        action: 'careersSubmit',
        inputFullName: '',
        inputLastName: '',
        inputNumber: '',
        inputEmail: '',
        position: '',
        date_of_emp: '',
        companyname: '',
        jobtitle: '',
        inputMessage: '',
        image1: '',
        image2: ''
    });

    const [BookFromErrors, setBookFromErrors] = useState({
        inputFullName: '',
        inputLastName: '',
        inputNumber: '',
        inputEmail: '',
        position: '',
        date_of_emp: '',
        companyname: '',
        jobtitle: '',
        inputMessage: '',
        image1: '',
        image2: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        
        if (name === "image1") {
            if (files) {
                const images = e.currentTarget.files[0];
                setBookFromData({
                    ...BookFromData,
                    image1: images
                });
                // Clear image1 error when file is selected
                if (BookFromErrors.image1) {
                    setBookFromErrors(prevState => ({
                        ...prevState,
                        image1: ''
                    }));
                }
            }
        } else if (name === "image2") {
            if (files) {
                const images12 = e.currentTarget.files[0];
                setBookFromData({
                    ...BookFromData,
                    image2: images12
                });
                // Clear image2 error when file is selected
                if (BookFromErrors.image2) {
                    setBookFromErrors(prevState => ({
                        ...prevState,
                        image2: ''
                    }));
                }
            }
        } else {
            setBookFromData(prevState => ({
                ...prevState,
                [name]: value
            }));

            // Clear error when user starts typing
            if (BookFromErrors[name]) {
                setBookFromErrors(prevState => ({
                    ...prevState,
                    [name]: ''
                }));
            }
        }
    };

    const validateForm = () => {
        const errors = {};
        let isValid = true;

        // Required fields validation
        if (!BookFromData.inputFullName.trim()) {
            errors.inputFullName = 'First Name is required';
            isValid = false;
        }

        if (!BookFromData.inputLastName.trim()) {
            errors.inputLastName = 'Last Name is required';
            isValid = false;
        }

        if (!BookFromData.inputNumber.trim()) {
            errors.inputNumber = 'Phone Number is required';
            isValid = false;
        } else if (!/^\d{10}$/.test(BookFromData.inputNumber.replace(/\D/g, ''))) {
            errors.inputNumber = 'Please enter a valid 10-digit phone number';
            isValid = false;
        }

        if (!BookFromData.inputEmail.trim()) {
            errors.inputEmail = 'Email Address is required';
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(BookFromData.inputEmail)) {
            errors.inputEmail = 'Please enter a valid email address';
            isValid = false;
        }

        if (!BookFromData.position) {
            errors.position = 'Please select a position';
            isValid = false;
        }

        if (!BookFromData.date_of_emp.trim()) {
            errors.date_of_emp = 'Dates of Employment is required';
            isValid = false;
        }

        if (!BookFromData.companyname.trim()) {
            errors.companyname = 'Company Name is required';
            isValid = false;
        }

        if (!BookFromData.jobtitle.trim()) {
            errors.jobtitle = 'Job Title is required';
            isValid = false;
        }

        if (!BookFromData.inputMessage.trim()) {
            errors.inputMessage = 'Summary of Responsibilities & Achievements is required';
            isValid = false;
        }

        if (!BookFromData.image1) {
            errors.image1 = 'Please upload your resume';
            isValid = false;
        }

        if (!BookFromData.image2) {
            errors.image2 = 'Please upload your cover letter';
            isValid = false;
        }

        setBookFromErrors(errors);
        return isValid;
    };

    const toastId = useRef(null);

    const BookhandleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            // toast.error('Please fill all required fields correctly');
            return false;
        }

        setIsSubmitting(true);
        toastId.current = toast.loading("Please Wait...");
        
        try {
            const formData = new FormData();
            formData.append('action', 'careersSubmit');
            formData.append('inputFullName', BookFromData.inputFullName);
            formData.append('inputLastName', BookFromData.inputLastName);
            formData.append('inputNumber', BookFromData.inputNumber);
            formData.append('inputEmail', BookFromData.inputEmail);
            formData.append('position', BookFromData.position);
            formData.append('date_of_emp', BookFromData.date_of_emp);
            formData.append('companyname', BookFromData.companyname);
            formData.append('jobtitle', BookFromData.jobtitle);
            formData.append('inputMessage', BookFromData.inputMessage);
            formData.append('image1', BookFromData.image1);
            formData.append('image2', BookFromData.image2);

            const response = await axios.post(`${process.env.REACT_APP_URL_MAIN}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.status === true) {
                toast.update(toastId.current, {
                    render: response.data.message,
                    type: "success",
                    autoClose: 5000,
                    closeOnClick: true,
                    isLoading: false
                });
                setBookFromData({
                    action: 'careersSubmit',
                    inputFullName: '',
                    inputLastName: '',
                    inputNumber: '',
                    inputEmail: '',
                    position: '',
                    date_of_emp: '',
                    companyname: '',
                    jobtitle: '',
                    inputMessage: '',
                    image1: '',
                    image2: ''
                });
                setBookFromErrors({
                    inputFullName: '',
                    inputLastName: '',
                    inputNumber: '',
                    inputEmail: '',
                    position: '',
                    date_of_emp: '',
                    companyname: '',
                    jobtitle: '',
                    inputMessage: '',
                    image1: '',
                    image2: ''
                });
            } else {
                toast.update(toastId.current, {
                    render: response.data.message,
                    type: "error",
                    autoClose: 5000,
                    closeOnClick: true,
                    isLoading: false
                });
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.update(toastId.current, {
                render: 'An error occurred. Please try again.',
                type: "error",
                autoClose: 5000,
                closeOnClick: true,
                isLoading: false
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <ToastContainer />
            
            {/* Add CSS for floating labels */}
            <style>
        {`
          .form-group-floating {
              position: relative;
              margin-bottom: 1.5rem;
          }
          
          .form-group-floating input,
          .form-group-floating select,
          .form-group-floating textarea {
              padding-top: 1.5rem;
              padding-bottom: 0.5rem;
              height: auto;
              width: 100%;
          }
          
          .form-group-floating .floating-label {
              position: absolute;
              top: 0.75rem;
              left: 0.75rem;
              font-size: 0.875rem;
              color: #6b7280;
              transition: all 0.2s ease-in-out;
              pointer-events: none;
              background: white;
              padding: 0 0.25rem;
              margin-left: -0.25rem;
              z-index: 1;
          }
          
          .form-group-floating input:focus ~ .floating-label,
          .form-group-floating input:not(:placeholder-shown) ~ .floating-label,
          .form-group-floating select:focus ~ .floating-label,
          .form-group-floating select:valid ~ .floating-label,
          .form-group-floating textarea:focus ~ .floating-label,
          .form-group-floating textarea:not(:placeholder-shown) ~ .floating-label {
              top: -0.5rem;
              left: 0.5rem;
              font-size: 0.75rem;
              color: #1e1e1fff;
          }
          
          .error-message {
              color: #dc2626;
              font-size: 0.875rem;
              margin-top: 0.25rem;
              display: block;
          }
          
          .servicepageinput1.error,
          .servicepageinput.error {
              border-color: #dc2626;
          }
          
          .btn-one:disabled {
              opacity: 0.6;
              cursor: not-allowed;
          }
          
          .file-upload-info {
              font-size: 0.875rem;
              margin-top: 0.25rem;
              display: block;
          }
        `}
      </style>

            <section className="js-block-masthead section section--masthead advanced py-5 bg-slider-explores">
                <div className="elementor-background-overlay"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 mx-auto bg-itm2 ">
                            <div className="text-center">
                                <h1 className="text-white pb-3">Empower Your Career in Commercial Food Service equipment with Middleby Celfrost</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ... All your existing sections remain exactly the same until the contact form section ... */}
            <section className={`section section6 bg-white section--products m-0 `}>

                <div className="container">
                    <div className="wysiwyg">
                        <h1 className="text-center fw-bold fs-2"></h1>
                        <hr />
                        <div className="row">
                            <div className="col-md-12 mx-auto px-3">
                                <h5 className="primarycolor text-center fw-normal">Middleby Celfrost, a premier destination for innovative and reliable foodservice equipment solutions. With a rich legacy spanning decades, Middleby is a Global leader in designing, manufacturing, and distributing a comprehensive range of cutting-edge commercial kitchen equipment.</h5>
                            </div>
                        </div>
                        <div className="row align-items-center justify-content-between">
                            <div className={`col-md-5 mb-5 section22 `}>

                                {/* <div className="col-md-5 mb-5"> */}
                                <img className="aboutimage1 p-0 mb-3 exp-img3" src={`${process.env.REACT_APP_API_URL}assets/img/exp-03.jpg`} />
                                <img className="aboutimage1 p-0 exp-img4" src={`${process.env.REACT_APP_API_URL}assets/img/exp-04.jpg`} />
                            </div>
                            <div className="col-md-6">
                                <h2 className="text-blue fw-bold">
                                    Why Choose Middleby Celfrost?
                                </h2>
                                <ul className="pt-2">
                                    <li><span className="fw-bold h4 primarycolor">Industry Leader : </span> We are a global company with a rich history of developing cutting-edge food service equipment solutions.</li>
                                    <li><span className="fw-bold h4 primarycolor">Passionate Team : </span> Our team is comprised of talented and dedicated individuals who are committed to excellence.</li>
                                    <li><span className="fw-bold h4 primarycolor">Innovation : </span> We foster a culture of creativity and invest heavily in research and development to bring the latest technologies to market.</li>
                                    <li><span className="fw-bold h4 primarycolor">Growth Opportunities : </span> We offer a dynamic work environment with opportunities for professional development and career advancement.</li>
                                    <li><span className="fw-bold h4 primarycolor">Competitive Benefits : </span> We provide a comprehensive benefits package that includes health insurance, paid time off, and retirement savings plans</li>
                                    {/* <li><span className="fw-bold h4 primarycolor">Colorfull : </span> black</li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className={`section section7 bg-black text-white section--products m-0`}>

                <div className="container">
                    <div className="wysiwyg">
                        <h1 className="text-center fs-2">
                            <strong><span>Current Openings</span></strong>
                        </h1><hr />
                        <div className="row align-items-center justify-content-between pt-0">
                            <div className="col-md-6">
                                <p className="mt-4">We are always looking for talented and motivated individuals to join our team. We have a variety of openings across different departments, </p>

                                <h2 className="text-wheat">Including:</h2>

                                <ul className="pt-2 list-unstyled">
                                    <li><span className="text-wheat">✔  Engineering</span></li>
                                    <li><span className="text-wheat">✔  Sales & Marketing</span></li>
                                    <li><span className="text-wheat">✔  Operations</span></li>
                                    <li><span className="text-wheat">✔  Finance & Accounting</span></li>
                                    <li><span className="text-wheat">✔  Human Resources</span></li>
                                </ul>

                                <p className="mt-4">What We Look For At Middleby Celfrost, we value candidates who possess the following </p>

                                <h2 className="text-wheat">Qualities:</h2>

                                <ul className="pt-2 list-unstyled">
                                    <li><span className="text-wheat">✔  A strong work ethic and a commitment to quality</span></li>
                                    <li><span className="text-wheat">✔  A collaborative spirit and the ability to work effectively in a team environment</span></li>
                                    <li><span className="text-wheat">✔  Excellent communication and interpersonal skills</span></li>
                                    <li><span className="text-wheat">✔  A passion for the food service industry (preferred)</span></li>
                                    <li><span className="text-wheat">✔  A proven track record of success in a relevant field (for experienced candidates)</span></li>
                                </ul>
                            </div>

                            <div className={`col-md-6 mb-5 section23 `}>
                                <img className="pizzeriaimage p-0 mb-3 exp-img1" src={`${process.env.REACT_APP_API_URL}assets/img/exp-05.jpg`} />
                                <img className="pizzeriaimage p-0 exp-img2" src={`${process.env.REACT_APP_API_URL}assets/img/exp-06.jpg`} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className={`section section6 bg-white section--products m-0 `}>

                <div className="container">
                    <div className="wysiwyg">
                        <h1 className="text-center fw-bold fs-2">Application Form</h1>
                        <hr />
                        <div className="row align-items-center justify-content-between">
                            <div className={`col-md-5 mb-5 section22 `}>
                                {/* <div className="col-md-5 mb-5"> */}
                                <img className="aboutimage1 p-0 mb-3 exp-img3" src={`${process.env.REACT_APP_API_URL}assets/img/exp-03.jpg`} />
                                <img className="aboutimage1 p-0 exp-img4" src={`${process.env.REACT_APP_API_URL}assets/img/exp-04.jpg`} />
                            </div>
                            <div className="col-md-6">
                                <h5 className="primarycolor fw-normal">How to Apply </h5>
                                <p>We encourage you to browse our current openings and submit your resume and cover letter online. We look forward to hearing from you!</p> <br />
                                <p>In addition to the above, you may consider including the following sections</p>
                                {/* <h2 className="text-blue fw-bold">Why Choose Middleby Celfrost?</h2> */}
                                <ul className="pt-2">
                                    <li><span className="fw-bold h4 primarycolor">Company Culture : </span> Briefly describe your company culture and work environment.</li>
                                    <li><span className="fw-bold h4 primarycolor">Employee Testimonials : </span> Include quotes from satisfied employees about their experience working at Middleby Celfrost.</li>
                                    <li><span className="fw-bold h4 primarycolor">Awards & Recognition : </span> Highlight any awards or recognition that Middleby Celfrost has received.</li>
                                    <li><span className="fw-bold h4 primarycolor">Benefits in Detail : </span> Provide a more detailed overview of the benefits package offered by Middleby Celfrost.</li>
                                    <li><span className="fw-bold h4 primarycolor">Social Media Links : </span> Include links to your company's social media pages (LinkedIn, Facebook, etc.).</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="contact-form-area mb-5" id="form">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-10 col-lg-10 px-5 pt-5 rounded-1 m-auto text-center box-shadow">
                            <strong className="car-title primarycolor">
                                Middleby Celfrost - Job Application Form
                            </strong>
                            <p className="text-center pt-2 pb-2">
                                Thank you for your interest in a career at Middleby Celfrost! To apply for a position, please complete all sections of this form and submit your resume and cover letter.
                            </p>
                            <div className="contact-form pt-3">
                                <form id="contact-form" name="contact_form" onSubmit={BookhandleSubmit} className="default-form2" method="post">
                                    <div className="row">
                                        <div className="col-xl-6 col-lg-6">
                                            {/* First Name */}
                                            <div className="form-group-floating mb-4">
                                                <input 
                                                    type="text"
                                                    onChange={handleChange}
                                                    className={`servicepageinput1 ${BookFromErrors.inputFullName ? 'error' : ''}`}
                                                    name="inputFullName"
                                                    value={BookFromData.inputFullName}
                                                    placeholder=" "
                                                    required
                                                />
                                                <label className="floating-label" htmlFor="inputFullName">First Name*</label>
                                                {BookFromErrors.inputFullName && <span className="error-message">{BookFromErrors.inputFullName}</span>}
                                            </div>

                                            {/* Email Address */}
                                            <div className="form-group-floating mb-4">
                                                <input 
                                                    type="email"
                                                    onChange={handleChange}
                                                    className={`servicepageinput1 ${BookFromErrors.inputEmail ? 'error' : ''}`}
                                                    name="inputEmail"
                                                    value={BookFromData.inputEmail}
                                                    placeholder=" "
                                                    required
                                                />
                                                <label className="floating-label" htmlFor="inputEmail">Email Address*</label>
                                                {BookFromErrors.inputEmail && <span className="error-message">{BookFromErrors.inputEmail}</span>}
                                            </div>

                                            {/* Position */}
                                            <div className="form-group-floating mb-4">
                                                <select 
                                                    className={`servicepageinput ${BookFromErrors.position ? 'error' : ''}`}
                                                    name="position"
                                                    value={BookFromData.position}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="">Select the position*</option>
                                                    <option value="Position 1">Position 1</option>
                                                    <option value="Position 2">Position 2</option>
                                                    <option value="Position 3">Position 3</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                                {/* <label className="floating-label" htmlFor="position">Position*</label> */}
                                                {BookFromErrors.position && <span className="error-message">{BookFromErrors.position}</span>}
                                            </div>

                                            {/* Company Name */}
                                            <div className="form-group-floating mb-4">
                                                <input 
                                                    type="text"
                                                    onChange={handleChange}
                                                    className={`servicepageinput1 ${BookFromErrors.companyname ? 'error' : ''}`}
                                                    name="companyname"
                                                    value={BookFromData.companyname}
                                                    placeholder=" "
                                                    required
                                                />
                                                <label className="floating-label" htmlFor="companyname">Company Name*</label>
                                                {BookFromErrors.companyname && <span className="error-message">{BookFromErrors.companyname}</span>}
                                            </div>
                                        </div>

                                        <div className="col-xl-6 col-lg-6">
                                            {/* Last Name */}
                                            <div className="form-group-floating mb-4">
                                                <input 
                                                    type="text"
                                                    onChange={handleChange}
                                                    className={`servicepageinput1 ${BookFromErrors.inputLastName ? 'error' : ''}`}
                                                    name="inputLastName"
                                                    value={BookFromData.inputLastName}
                                                    placeholder=" "
                                                    required
                                                />
                                                <label className="floating-label" htmlFor="inputLastName">Last Name*</label>
                                                {BookFromErrors.inputLastName && <span className="error-message">{BookFromErrors.inputLastName}</span>}
                                            </div>

                                            {/* Phone Number */}
                                            <div className="form-group-floating mb-4">
                                                <input 
                                                    type="text"
                                                    onChange={handleChange}
                                                    className={`servicepageinput1 ${BookFromErrors.inputNumber ? 'error' : ''}`}
                                                    name="inputNumber"
                                                    value={BookFromData.inputNumber}
                                                    placeholder=" "
                                                    required
                                                />
                                                <label className="floating-label" htmlFor="inputNumber">Phone Number*</label>
                                                {BookFromErrors.inputNumber && <span className="error-message">{BookFromErrors.inputNumber}</span>}
                                            </div>

                                            {/* Dates of Employment */}
                                            <div className="form-group-floating mb-4">
                                                <input 
                                                    type="text"
                                                    onChange={handleChange}
                                                    className={`servicepageinput1 ${BookFromErrors.date_of_emp ? 'error' : ''}`}
                                                    name="date_of_emp"
                                                    value={BookFromData.date_of_emp}
                                                    placeholder=" "
                                                    required
                                                />
                                                <label className="floating-label" htmlFor="date_of_emp">Dates of Employment (Month/Year - Month/Year)*</label>
                                                {BookFromErrors.date_of_emp && <span className="error-message">{BookFromErrors.date_of_emp}</span>}
                                            </div>

                                            {/* Job Title */}
                                            <div className="form-group-floating mb-4">
                                                <input 
                                                    type="text"
                                                    onChange={handleChange}
                                                    className={`servicepageinput1 ${BookFromErrors.jobtitle ? 'error' : ''}`}
                                                    name="jobtitle"
                                                    value={BookFromData.jobtitle}
                                                    placeholder=" "
                                                    required
                                                />
                                                <label className="floating-label" htmlFor="jobtitle">Job Title*</label>
                                                {BookFromErrors.jobtitle && <span className="error-message">{BookFromErrors.jobtitle}</span>}
                                            </div>
                                        </div>

                                        {/* File Uploads */}
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group-floating mb-4">
                                                    <input 
                                                        type="file"
                                                        onChange={handleChange}
                                                        className={`servicepageinput ${BookFromErrors.image1 ? 'error' : ''}`}
                                                        name="image1"
                                                        accept=".doc, .docx, .pdf"
                                                        required
                                                    />
                                                    <label className="floating-label" htmlFor="image1">Upload Resume*</label>
                                                    {BookFromErrors.image1 && <span className="error-message">{BookFromErrors.image1}</span>}
                                                    {BookFromData.image1 && (
                                                        <span className="file-upload-info text-success">
                                                            Selected: {BookFromData.image1.name}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                           
                                            <div className="col-lg-6">
                                                <div className="form-group-floating mb-4">
                                                    <input 
                                                        type="file"
                                                        onChange={handleChange}
                                                        className={`servicepageinput ${BookFromErrors.image2 ? 'error' : ''}`}
                                                        name="image2"
                                                        accept=".doc, .docx, .pdf"
                                                        required
                                                    />
                                                    <label className="floating-label" htmlFor="image2">Upload Cover Letter*</label>
                                                    {BookFromErrors.image2 && <span className="error-message">{BookFromErrors.image2}</span>}
                                                    {BookFromData.image2 && (
                                                        <span className="file-upload-info text-success">
                                                            Selected: {BookFromData.image2.name}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Summary of Responsibilities & Achievements */}
                                        <div className="col-xl-12 col-lg-12">
                                            <div className="form-group-floating mb-4">
                                                <textarea 
                                                    onChange={handleChange}
                                                    className={`servicepageinput1 ${BookFromErrors.inputMessage ? 'error' : ''}`}
                                                    name="inputMessage"
                                                    value={BookFromData.inputMessage}
                                                    placeholder=" "
                                                    rows="4"
                                                    required
                                                />
                                                <label className="floating-label" htmlFor="inputMessage">Summary of Responsibilities & Achievements*</label>
                                                {BookFromErrors.inputMessage && <span className="error-message">{BookFromErrors.inputMessage}</span>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="button-box text-center">
                                                <input id="form_botcheck" name="form_botcheck" className="form-control" type="hidden" value="" />
                                                <button 
                                                    className="btn-one" 
                                                    type="submit" 
                                                    disabled={isSubmitting}
                                                >
                                                    <span className="txt">
                                                        {isSubmitting ? 'Submitting...' : 'Submit'}
                                                    </span>
                                                </button>
                                            </div>
                                            <br />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}